import React from 'react';
import styles from './Contact.module.scss';

export const Contact: React.FC = () => {
  return (
    <section id="contact" className="chapter">
      <div className='container'>
        <div className='box'>
            <div className='card_title'>
              <h1 className={styles.card_title_img}>お問い合わせ</h1>
            </div>
            <div className={'card_content' + ' ' + styles.bg}>
              <p className={styles.text}>
                info@miistin.com
              </p>
            </div>
          </div>
      </div>
    </section>
  );
};
